/**
 * Адрес в БД/legacy может быть строкой или объектом (DaData и т.п.).
 */
export function formatAddressForDisplay(raw) {
  if (raw == null || raw === '') return '';
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (t === '[object Object]') return '';
    return t;
  }
  if (typeof raw !== 'object') return String(raw);
  const o = raw;
  if (typeof o.address_label === 'string' && o.address_label.trim()) {
    return o.address_label.trim();
  }
  if (typeof o.value === 'string' && o.value.trim()) return o.value.trim();
  if (typeof o.unrestricted_value === 'string' && o.unrestricted_value.trim()) {
    return o.unrestricted_value.trim();
  }
  if (typeof o.result === 'string' && o.result.trim()) return o.result.trim();
  if (typeof o.label === 'string' && o.label.trim()) return o.label.trim();
  if (typeof o.hand_address === 'string' && o.hand_address.trim()) return o.hand_address.trim();
  const line = [o.city_with_type, o.street_with_type, o.house, o.block, o.flat]
    .filter((x) => x != null && String(x).trim() !== '')
    .map((x) => String(x).trim())
    .join(', ');
  if (line) return line;
  try {
    return JSON.stringify(o);
  } catch {
    return '';
  }
}

/** Текстовые поля (описание), если вдруг пришёл не string. */
export function formatTextFieldForInput(raw) {
  if (raw == null || raw === '') return '';
  if (typeof raw === 'string') return raw;
  if (typeof raw === 'object' && typeof raw.text === 'string') return raw.text;
  if (typeof raw === 'object') {
    try {
      return JSON.stringify(raw, null, 2);
    } catch {
      return String(raw);
    }
  }
  return String(raw);
}
